module.exports = __webpack_public_path__ + "static/media/2.bbe37ee8.png";